import React from 'react'
import Group from 'components/utils/Group'
import CruiseSearchForm from 'components/Cruises/SearchPage/Filters/Inputs/CruiseSearchInputs'

function CruisesTabContent() {
  return <Group direction="vertical" gap={16}>
    <CruiseSearchForm />
  </Group>
}

export default CruisesTabContent
